// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"b2ee8443","977":"e3e6360d"}[chunkId] + ".chunk.js";
};